// eslint-disable
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Divider from '@material-ui/core/Divider';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { Button as RMDButton, CircularProgress } from 'react-md';

import { compact, get } from 'lodash-es';

import OfferGrid from './OfferGrid';
import OfferDate from './OfferDate';
import ValidationMessage from '../../Common/ValidationMessage';
import I18nMarkdown from '../../Common/i18nMarkdown';

import CurrencyNumberFormat from '../../Common/CurrencyNumberFormatComponent';

class OfferBlock extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: '',
    };
  }

  static componentDidMount() {
    const { expanded } = this.props;
    this.setState({
      expanded,
    });
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { expanded } = nextProps;
    let newState = null;
    if (expanded !== prevState.expanded) {
      newState = newState ? Object.assign(newState, { expanded }) : { expanded };
    }
    return newState;
  }

  render() {
    const {
      formApi,
      onCalculate,
      onPrint,
      dataCalc,
      type,
      setExpanded,
      strings,
      classes,
      isLoan,
      readOnly,
      actionsState,
      validate,
      ...props
    } = this.props;
    const { expanded } = this.state;

    const isCalculable = get(actionsState, 'btn.calculated.disable', false);

    const toggleExpanded = () => {
      setExpanded('offer', !expanded);
    };

    const renderGrid = () => {
      const { columns, data, loading } = props;

      if (loading) return <CircularProgress id="loading-anim-offer" />;
      return Array.isArray(columns) && Array.isArray(data) && columns.length > 0 && data.length > 0 ? (
        <OfferGrid data={data} columns={columns} strings={strings} />
      ) : (
        <></>
      );
    };

    const documentList = documentGroup => {
      const documents = documentGroup.map((formality, idx) => (
        <li key={idx}>
          <I18nMarkdown
            string={`${formality?.type?.description} ${formality?.type?.custom_resources?.caption ? formality?.type?.custom_resources?.caption : ''
              }`}
            defaultValue={`${formality?.type?.description} ${formality?.type?.custom_resources?.caption ? formality?.type?.custom_resources?.caption : ''
              }`}
          />
        </li>
      ));
      return <ul className="documents">{documents}</ul>;
    };

    const renderServices = () => {
      const { offer, loading } = props;

      if (loading) return <CircularProgress id="loading-anim-offer" />;

      if (offer?.services?.length) {
        // PPOP-922 : Check if at least one coverageCode start with 'met_prev_pro' or 'met_prev_fam_hd'
        // to determine if we need to show the box caption.
        const showBoxCaption = offer.services.some(
          service =>
            service?.coverageCode?.startsWith('met_prev_pro') || service?.coverageCode?.startsWith('met_prev_fam_hd')
        );

        const servicesBlock = offer.services.map((service, idx) => {
          const hidden = service?.code?.endsWith('__hidden');
          return (
            <li key={`${idx}---${service?.coverageCode}---${service?.code}`} className={hidden ? 'hidden' : ''}>
              <span className="label">{`${service?.label} : `}</span>
              <span className="amount">
                <CurrencyNumberFormat value={service?.amount} displayType="text" />
              </span>
            </li>
          );
        });

        return (
          <div className="servicesBox-34534534501b">
            <span className="boxTitle">Prestations</span>
            {showBoxCaption && (
              <span className="boxCaption">
                Si le type de prestation est Indemnitaire, alors les montants ci-dessous incluent la part prise en
                charge par le RO
              </span>
            )}
            <div className="boxBlock">
              <ul>{servicesBlock}</ul>
            </div>
          </div>
        );
      }
      return <></>;
    };

    const renderFormalities = () => {
      const { offer, loading } = props;
      if (loading) return <CircularProgress id="loading-anim-offer" />;
      let formalitiesBlock;
      if (offer?.formalities?.length) {
        formalitiesBlock = offer?.formalities.map((formalityGroup, idx) => (
          <div className="formalities" key={idx}>
            <div className="title">
              <I18nMarkdown string={formalityGroup?.name} defaultValue={formalityGroup?.name} />
            </div>
            <div className="caption">
              <I18nMarkdown
                string={formalityGroup?.custom_resources?.caption}
                defaultValue={formalityGroup?.custom_resources?.caption}
              />
            </div>
            <div className="list">{documentList(formalityGroup?.documents)}</div>
            {JSON.stringify(offer?.formalities[0]?.documents[0].description)}
          </div>
        ));
      }
      return offer?.formalities ? (
        <div className="formalitiesBox-34534534501b">
          <span className="boxTitle">Formalités</span>
          <div className="formalitiesBox">{formalitiesBlock}</div>
        </div>
      ) : (
        <></>
      );
    };

    const handleCalculate = e => {
      e.stopPropagation();
      let subvalues = get(formApi.getState(), 'values');
      if (subvalues.subscriptions) {
        subvalues = { ...subvalues, subscriptions: compact(get(subvalues, 'subscriptions', [])) };
      }
      if (dataCalc.subscriber_kind === 'company') {
        if (!subvalues.transform) {
          subvalues.transform = {};
        }
        subvalues.transform = { ...subvalues.transform, party: { ...subvalues.transform.party, is_person: false } };
      }
      onCalculate(subvalues);
    };

    const handlePrint = e => {
      e.stopPropagation();
      let subvalues = get(formApi.getState(), 'values');
      if (subvalues.subscriptions) {
        subvalues = { ...subvalues, subscriptions: compact(get(subvalues, 'subscriptions', [])) };
      }
      onPrint(subvalues);
    };

    const renderOffer = () => {
      switch (type) {
        case 'grid':
          return renderGrid();
        case 'card':
          return <div>Not implemented yet...</div>;
        default:
          return renderGrid();
      }
    };

    const specialMessage = () => {
      const { data } = props;
      return data[0]?.id?.startsWith('met_prev_pro') ? (
        <div className="special-message-for-met_prev_pro">
          <p></p>
          <h5>
            <i>de la date d&apos;effet du contrat au 31/12 de la même année</i>
          </h5>
        </div>
      ) : (
        <></>
      );
    };

    return (
      <>
        <div className="block actions offer">
          <OfferDate formApi={formApi} strings={strings} isLoan={isLoan} readOnly={readOnly} />
          <div className="button-block">
            <RMDButton
              raised
              secondary
              iconBefore={false}
              // swapTheming
              iconChildren="euro_symbol"
              onClick={handleCalculate}
              disabled={readOnly || isCalculable}
            >
              {strings['btn.calculate.label'] || 'Calculate'}
            </RMDButton>
          </div>
          <ValidationMessage validate={validate} path="quotation" />
        </div>
        <ExpansionPanel
          className={`offerPanel expansion-panel ${expanded ? 'expanded' : ''}`}
          expanded={expanded}
          onChange={toggleExpanded}
          style={{ marginTop: '16px' }}
        >
          <ExpansionPanelSummary
            className="expansion-panel-summary"
            expandIcon={<ExpandMoreIcon className="expansion-more-icon" />}
          >
            <span className="extra-block-title" style={{ marginRight: '10px' }}>
              {strings['block.offer.title'] || `Projet d'assurance`}
            </span>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className={classes.details}>
            <div className="container-offerbox">
              {renderServices()}
              <div className="offerBox">
                <span className="boxTitle">Tarification</span>
                {specialMessage()}
                {renderOffer()}
              </div>
              {renderFormalities()}
            </div>
          </ExpansionPanelDetails>
          <Divider />
          <ExpansionPanelActions className="block actions">
            <div className="button-block">
              <RMDButton
                raised
                secondary
                iconBefore={false}
                swapTheming
                iconChildren="print"
                onClick={handlePrint}
                disabled={get(actionsState, 'btn.print.disable', false)}
              >
                {get(strings, 'btn.print.label', 'Print')}
              </RMDButton>
            </div>
            <ValidationMessage validate={validate} path="print" />
          </ExpansionPanelActions>
        </ExpansionPanel>
      </>
    );
  }
}

OfferBlock.propTypes = {
  type: PropTypes.oneOf(['grid', 'card']),
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    })
  ),
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    })
  ),
  dataCalc: PropTypes.any, // eslint-disable-line
  loading: PropTypes.bool,
  expanded: PropTypes.bool.isRequired,
  setExpanded: PropTypes.func.isRequired,
  onCalculate: PropTypes.func.isRequired,
  onPrint: PropTypes.func.isRequired,
  formApi: PropTypes.any.isRequired, // eslint-disable-line
  strings: PropTypes.object.isRequired, // eslint-disable-line
  classes: PropTypes.any.isRequired, // eslint-disable-line
  isLoan: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool.isRequired,
  actionsState: PropTypes.any, // eslint-disable-line
  validate: PropTypes.object.isRequired, // eslint-disable-line
  offer: PropTypes.object.isRequired, // eslint-disable-line
};

OfferBlock.defaultProps = {
  type: 'grid',
  columns: [],
  data: [],
  dataCalc: {},
  loading: false,
  actionsState: {
    btn: {
      print: {
        disable: false,
      },
      calculated: {
        disable: false,
      },
    },
  },
};

export default OfferBlock;
